import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { urlConfig } from '../config';
import { store } from '../app/store';

const httpLink = createHttpLink({
  uri: `${urlConfig.transactionHistoryUrl}/transactions/graphql`,
});

const authLink = setContext((_, { headers }) => {
  // Get the authentication token from local storage or Redux store
  const state = store.getState();
  const token = state.auth.token;

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  }
});

export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'all',
    },
    query: {
      errorPolicy: 'all',
    },
  },
}); 